import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { ProjecaoColetoresTabela } from "../../projecao-formulario/projecao-coletores-tabela";
import styles from "./cartao-projecao-transferencia.module.scss";
import type { CartaoProjecaoTransferenciaViewModel } from "./types-cartao-projecao-transferencia";

export function CartaoProjecaoTransferenciaView({
  visivel,
  titulo,
  texto,
  ajustada,
  ajustarLabel,
  tabela,
  ajustar,
}: CartaoProjecaoTransferenciaViewModel) {
  if (!visivel) return null;

  return (
    <section className={styles.cartao} data-testid="transferir-projecao-cartao">
      <header className={styles.cabecalho}>
        <div className={styles.titulos}>
          <h4 className={styles.titulo}>{titulo}</h4>
          <p className={styles.texto}>{texto}</p>
        </div>
        {ajustada ? (
          <Tag value={ajustada} severity="info" data-testid="transferir-projecao-ajustada" />
        ) : null}
        <Button
          type="button"
          size="small"
          outlined
          severity="secondary"
          label={ajustarLabel}
          onClick={ajustar}
          data-testid="transferir-ajustar-projecao"
        />
      </header>
      <ProjecaoColetoresTabela {...tabela} />
    </section>
  );
}
